import { useEffect, useRef } from 'preact/hooks';
import MessageChatbot from '/src/components/messageChatbot';
import LoadingMessageChatBot from '/src/components/loadingMessageChatbot';
import clsx from 'clsx';


export default function HistoryChatbot({modeChatbot, navigationStateChatbot, welcomeNavigationStateChatbot,messages, isLoadingState}) {
  const messagesEndRef = useRef(null); // Reference at the bottom of the message container.
  const messagesLength = messages.length;

  // Function to scroll down in the message container.
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const isFirstMessage = (item, i) => {
    return i === 0 || (messages[i] && messages[i].id !== item.id);
  }
  const isLastMessage = (item, i) => {
    return i === messages.length - 1 || (messages[i] && messages[i].id !== item.id);
  }

  return (
    <div className='bot-utn-messages-container bot-utn-scrollbar'>
      {messages.map((message, index) => (
        <>
          {index === messagesLength - 1 && <div ref={messagesEndRef}/>}
          <MessageChatbot
              modeChatbot={modeChatbot}
              welcomeNavigationStateChatbot={welcomeNavigationStateChatbot}
              {...{item: message, index, isLastMessage, isFirstMessage}} />
        </>
      ))}
      <LoadingMessageChatBot isLoadingState={isLoadingState} modeChatbot={modeChatbot} navigationStateChatbot={navigationStateChatbot}/>
    </div>
  );

}
